<template>
  <div></div>
</template>

<script>
import { mapGetters } from 'vuex'
import EventBus from '@/eventBus'
import VueToastedUtils from '@/utils/vue-toasted.utils.js'
import utils from '@/util'
import { IMPORT_OPTIONS } from '@/constant/eventActions/ImportEventActions.js'

export default {
  data() {
    return {
      currentToast: null,
      title: 'Importing slides…',
    }
  },

  computed: {
    ...mapGetters('aiChatbotImportPptxPdf', ['isCurrentPresentationImportingSlides', 'selectedImportOption']),

    shouldShowToaster() {
      const isImportOnly = this.selectedImportOption === IMPORT_OPTIONS.IMPORT_ONLY
      return this.isCurrentPresentationImportingSlides && isImportOnly
    },
    importErrorText() {
      return `${this.$i18nPresenter.t('Import failed')}.`
    },
  },

  watch: {
    shouldShowToaster(newValue) {
      if (!newValue) return

      this.showImportingToaster()
    },
  },

  mounted() {
    EventBus.$on('import: hide_is_importing_toaster', () => {
      this.hideCurrentToaster()
    })
    EventBus.$on('import: show_import_status_success', () => {
      this.showSuccessToaster()
    })
    EventBus.$on('import: show_import_status_error', () => {
      this.showErrorToaster()
    })

    if (this.shouldShowToaster) {
      this.showImportingToaster()
    }
  },

  destroyed() {
    EventBus.$off('import: hide_is_importing_toaster')
    EventBus.$off('import: show_import_status_success')
    EventBus.$off('import: show_import_status_error')
  },

  methods: {
    showImportingToaster() {
      this.currentToast = VueToastedUtils.showToast(this.$i18nPresenter.t(this.title), {}, {
        className: 'custom-toast__loading',
        hasReturnValue: true,
        action: {
          text: this.$i18nPresenter.t('Dismiss'),
          onClick: (e, toastObject) => {
            toastObject.goAway(0)
          },
        },
      })
    },

    hideCurrentToaster() {
      if (this.currentToast) {
        this.$toasted.clear()
      }
    },

    async showSuccessToaster() {
      this.hideCurrentToaster()
      await utils.sleep(500)
      this.currentToast = VueToastedUtils.showToast(this.$i18nPresenter.t('Your slides are ready!'), {}, {
        className: 'custom-toast__success',
        hasReturnValue: true,
        duration: 3000,
      })
    },

    async showErrorToaster() {
      this.hideCurrentToaster()
      await utils.sleep(500)
      this.currentToast = VueToastedUtils.showToast(this.importErrorText, {}, {
        className: 'custom-toast__error',
        hasReturnValue: true,
        duration: 3000,
      })
    },
  },
}
</script>
